<template>
  <div>
    <div v-for="item in options" :key="item.value">
      <b-form-radio name="radios" :checked="value" :value="item.value" @input="emitInput">
        {{ item.text }}
      </b-form-radio>

      <radio-items :all="all" :items="getChildren(item)" :class="{'ml-3': $dir.ltr, 'mr-3': $dir.rtl}" :value="value" @input="emitInput"/>
    </div>
  </div>
</template>

<script>
import RadioItems from './RadioItems'

export default {
  name: 'RadioItems',
  components: {
    RadioItems
  },
  props: {
    value: Number,
    all: { type: Array, required: true },
    items: { type: Array, required: true },
    parentId: String
  },
  computed: {
    options () {
      return this.items.map(item => {
        return {
          value: item.id,
          text: item.name
        }
      })
    }
  },
  methods: {
    getChildren (item) {
      return this.all.filter(i => i.parentId === item.value)
    },
    emitInput (itemId) {
      this.$emit('input', itemId)
    }
  }
}
</script>
